import React from 'react';

import {StyledModalFooter} from 'app/components/general/TabbedModal';
import {getContentType} from 'app/utils/content-type';
import {getObjectName} from 'app/utils/fallbacks';
import {gt} from 'app/utils/i18n';

import {QRCodeImage} from './QRCodeImage';

import type {BaseActionableDocumentType} from 'app/general/types';

type Props = {
  object: BaseActionableDocumentType;
  onCancel: () => void;
};

export function ShareQRCodeModalPane({object, onCancel}: Props) {
  const contentType =
    object.content_type === 'document'
      ? object.document_content_type
      : object.content_type;
  const hashid =
    object.content_type === 'document' ? object.document.hashid : object.hashid;
  const translationArgs = {
    name: <b>{getObjectName(object, contentType, true)}</b>,
    ct: getContentType(contentType).name,
  };

  if (contentType === 'quiz') {
    return null;
  }

  return (
    <div>
      <div className="pb-2">
        <p>{gt('Share or print %(name)s %(ct)s QR Code.', translationArgs)}</p>
        <div className="text-center">
          <QRCodeImage
            contentType={contentType}
            hashid={hashid}
            style={{width: 195, height: 195}}
            className="img-fluid border rounded"
            alt={gt('Document QR Code')}
          />
          <p className="font-italic text-muted small mt-3">
            {object.content_type == 'proceduregroup' ||
            ('private' in object && object.private) ||
            contentType === 'proceduregroup'
              ? gt('Access for logged in teammates with proper permission.')
              : gt('Access for anyone who scans the QR code.')}
          </p>
        </div>
      </div>
      <StyledModalFooter>
        <button
          onClick={onCancel}
          className="btn btn-link text-secondary"
          data-dismiss="modal"
        >
          <i className="fa fa-times mr-1" /> {gt('Close')}
        </button>
      </StyledModalFooter>
    </div>
  );
}
